export class UploadedFile {
    public FileName: string;
    public FileContent: string;
    constructor(fileName: string, fileContent: string){
        this.FileName = fileName;
        this.FileContent = fileContent;
    }
}